import { useEffect, useState } from 'react'
import {useNavigate} from 'react-router-dom'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import { useAuth } from '../../../../../../auth'
import { getCRUD } from '../../../../../companies/company-list/core/_requests'
import {useListView} from '../../core/ListViewProvider'
import {SupportListFilter} from './SupportListFilter'

const ClinicListToolbar = () => {
  const navigate = useNavigate()
  const openAddUserModal = () => {
    navigate('/portal-agency-support/add')
  }
  const {currentUser}=useAuth();
  const [roleaccess, setroleaccess] = useState<any>([]);
  
  useEffect(() => {
    getCRUD(currentUser?.role,35).then((res: any) => {
      var crudres=res.data?.Data[0];
      setroleaccess(crudres);

    })
  }, [])
  return (
    <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
      {/* <CompanyListFilter /> */}
<SupportListFilter/>
      {/* begin::Add user */}
      {roleaccess?.add===1 ? (<button type='button'      className='btn text-white' style={{background: '#9E2A8D'}}  onClick={openAddUserModal}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2 text-white' />
        Add Support
      </button>):("")}
      {/* end::Add user */}
    </div>
  )
}

export {ClinicListToolbar}
